import { store } from '../store'
// import { EVENTS } from './events'
// import googleAnalyticsUtils from './google-analytics-utils'
import moEngageUtils from './mo-engage-utils'

const trackEvent = (eventName = '', eventData = {}) => {
  const {
    auth: { patientDetails, verifyOtp },
    authentication: { userDetailsState },
  } = store.getState()
  const userInfo =
    userDetailsState?.data || patientDetails?.data || verifyOtp?.data?.data
  const eventDataWithUser = {
    ...eventData,
    mobile_number: userInfo?.contactNo || 'NA',
    therapy_area: userInfo?.therapyArea || 'NA',
    disease: userInfo?.disease || 'NA',
  }
  // console.log("eventDataWithUser", eventDataWithUser);
  try {
    moEngageUtils.trackEvent(eventName, eventDataWithUser)
  } catch (error) {
    console.error('Error tracking event:', error)
  }
}

const setUserAttributes = (attributes = {}) => {
  try {
    moEngageUtils.setUserAttributes(attributes)
  } catch (error) {
    console.error('Error tracking event:', error)
  }
}

const logout = () => {
  try {
    moEngageUtils.logout()
  } catch (error) {
    console.error('Error logging out of moengage:', error)
  }
}

export const initAnalytics = () => {
  moEngageUtils.initialize()
}
export const analytics = {
  setUserProperties: (user) => {
    moEngageUtils.setUserAttributes(user)
  },
  logout: () => {
    moEngageUtils.logout()
  },
}
export { trackEvent, setUserAttributes, logout }
